import CommonUiModel from "../common/commonUiModel";

const ScopeScreenModel = new CommonUiModel({
  api: "AllScopeScreen",
  permissions: { add: false, edit: false, delete: false },
  idProperty: 'ScopeModelId',
  formTitle: 'Validated Scopes',
  gridTitle: 'View All Master Scopes',
  showHistory: false,
  nestedGrid: true,
  customActions: [{
    title: "navigateToRelation",
    icon: "article", // a string name, see note below
    onClick: ({ row, navigate }) => {
      navigate?.(`/masterScope/${row?.ScopeModelId}?showRelation=Document`);
    }
  }],
  columns: [
    { field: 'ScopeTypeId', label: 'Scope Type', width: 150, type: 'select', lookup: 'ScopeType', selectField: 'ScopeTypeId' },
    { field: 'ManufacturerId', label: 'Manufacturer', width: 150, type: 'select', lookup: 'manufacturer', selectField: 'ManufacturerId' },
    { field: 'ScopeModel', label: 'Scope Model', width: 150, type: 'string' },
    { field: 'Channels', label: 'Channels', width: 100, type: 'string' },
    { field: 'Notes', label: 'Notes', type: 'string', min: 3, multiline: true, variant: 'outlined' },
    { field: 'ScopeModelAlias', label: 'Alias', type: "chipInput", required: false, lookup: 'scopeModelAlias', width: 300 },
    { field: 'EquipmentNames', label: 'Equipments' }
  ]
});

export default ScopeScreenModel;